exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// C:/Users/Pujaalaxmi.K/Documents/PAA-Angular version 2/node_modules/css-loader?{"sourceMap":false,"importLoaders":1}!C:/Users/Pujaalaxmi.K/Documents/PAA-Angular version 2/node_modules/postcss-loader?{"ident":"postcss"}!C:/Users/Pujaalaxmi.K/Documents/PAA-Angular version 2/src/styles.css
// module id = ../../../../css-loader/index.js?{"sourceMap":false,"importLoaders":1}!../../../../postcss-loader/index.js?{"ident":"postcss"}!../../../../../src/styles.css
// module chunks = styles